import { VehicleFieldsModel } from '../../type/entities/vehicle-type';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/vehicle';

export class VehicleService extends RestServiceConnection {

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREA UN NUEVO VEHÍCULO
     * @EN CREATES A NEW VEHICLE
     * 
     * @param vehicle
     */
    //-------------------------------------------------------------------------------------------------------------
    createVehicle = async (vehicle: VehicleFieldsModel) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: vehicle,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES ACTUALIZA UN VEHÍCULO
     * @EN UPDATES A VEHICLE
     * 
     * @param vehicle
     */
    //-------------------------------------------------------------------------------------------------------------
    editVehicle = async (vehicle: VehicleFieldsModel & { id: string }) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: vehicle,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES LISTA LOS VEHÍCULOS
     * @EN LISTS THE VEHICLES
     * 
     * @param filters
     */
    //-------------------------------------------------------------------------------------------------------------
    listVehicles = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UN VEHÍCULO POR ID
     * @EN GETS A VEHICLE BY ID
     * 
     * @param vehicleId
     */
    //-------------------------------------------------------------------------------------------------------------
    getVehicleById = async (vehicleId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: {
                id: vehicleId
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES TOGGLES UN VEHÍCULO
     * @EN TOGGLES A VEHICLE
     * 
     * @param vehicleId
     * @param active
     */
    //-------------------------------------------------------------------------------------------------------------
    toggleVehicleStatus = async (vehicleId: string, active: boolean) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle',
            data: {
                id: vehicleId,
                active
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UN VEHÍCULO
     * @EN DELETES A VEHICLE
     * 
     * @param vehicleId
     */
    //-------------------------------------------------------------------------------------------------------------
    deleteVehicle = async (vehicleId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: {
                id: vehicleId
            }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA VARIOS VEHÍCULOS
     * @EN DELETES MULTIPLE VEHICLES
     * 
     * @param vehicleIds
     */
    //-------------------------------------------------------------------------------------------------------------
    deleteMultiVehicles = async (vehicleIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multi',
            data: {
                ids: vehicleIds
            }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE ESTADÍSTICAS DE VEHÍCULOS
     * @EN GETS VEHICLE STATISTICS
     */
    //-------------------------------------------------------------------------------------------------------------
    getVehicleStatistics = async () => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/statistics',
            data: {},
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES LISTA LOS VEHÍCULOS PARA SELECT
     * @EN LISTS THE VEHICLES FOR SELECT
     * 
     * @param filters
     */
    //-------------------------------------------------------------------------------------------------------------
    listSelectVehicles = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-select',
            data: filters,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES MARCA UN VEHÍCULO COMO VENDIDO
     * @EN MARKS A VEHICLE AS SOLD
     * 
     * @param vehicleId
     */
    //-------------------------------------------------------------------------------------------------------------
    markAsSold = async (vehicleId: string, selectedDate: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/sell_vehicle',
            data: {
                id: vehicleId,
                saleDate: selectedDate,
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------
}